import { useDispatch, useSelector } from "react-redux";
import { actionAddToShoppingCart, actionRemoveFromShoppingCart } from '../redux/actions/shoppingCart';


export const useCartHandlers = (selectedVariant, product, slug) => {

    const dispatch = useDispatch();
    const { carts } = useSelector(state => state.shoppingCart);


    /* mavaredi mesle joziyate mahsool k faghat 1 mahsool darim estefade mishavad */
    const handleAddToCart = (seller) => {
        const isInCartLocal = carts?.find(
            (cart) => cart.sku === selectedVariant?.sku && cart.seller.id === seller?.id
        );

        dispatch(actionAddToShoppingCart({
            product, 
            selectedVariant,
            seller,
            sku: selectedVariant.sku,
            title: product.title,
            number: isInCartLocal ? isInCartLocal.number + 1 : 1,
            image: product.image,
            price: parseInt(seller.price),
            priceSeparate: seller.priceTxt,
            marketPrice: parseInt(seller.oldPrice),
            marketPriceSeparate: seller.oldPriceTxt,
            slug
        }));
    };


    /* mavaredi mesle sabade kharid k chand mahsool darim estefade mishavad */
    const handleAddToCartTwo = (seller, selectedVariant, product, slug) => {
        const isInCartLocal = carts?.find(
            (cart) => cart.sku === selectedVariant?.sku && cart.seller.id === seller?.id
        );

        dispatch(actionAddToShoppingCart({
            product, 
            selectedVariant,
            seller,
            sku: selectedVariant.sku,
            title: product.title,
            number: isInCartLocal ? isInCartLocal.number + 1 : 1,
            image: product.image,
            price: parseInt(seller.price),
            priceSeparate: seller.priceTxt,
            marketPrice: parseInt(seller.oldPrice),
            marketPriceSeparate: seller.oldPriceTxt,
            slug
        }));
    };


    /* mavaredi mesle joziyate mahsool k faghat 1 mahsool darim estefade mishavad */
    const handleMinusBtn = (seller) => {
        const isInCartLocal = carts?.find(
            (cart) => cart.sku === selectedVariant?.sku && cart.seller.id === seller?.id
        );
        const new_number = isInCartLocal?.number - 1;

        if (new_number > 0) {
            dispatch(actionAddToShoppingCart({
                product, 
                selectedVariant, 
                seller,
                sku: selectedVariant.sku,
                title: product.title,
                number: new_number,
                image: product.image, 
                price: parseInt(seller.price), 
                priceSeparate: seller.priceTxt, 
                marketPrice: parseInt(seller.oldPrice),
                marketPriceSeparate: seller.oldPriceTxt,
                slug
            }));
        } else {
            dispatch(actionRemoveFromShoppingCart({
                product, 
                selectedVariant, 
                seller,
                sku: selectedVariant.sku,
                title: product.title,
                number: 0,
                image: product.image, 
                price: parseInt(seller.price), 
                priceSeparate: seller.priceTxt, 
                marketPrice: parseInt(seller.oldPrice),
                marketPriceSeparate: seller.oldPriceTxt,
                slug
            }));
        }
    };


    /* mavaredi mesle sabade kharid k chand mahsool darim estefade mishavad */
    const handleMinusBtnTwo = (seller, selectedVariant, product, slug) => {
        const isInCartLocal = carts?.find(
            (cart) => cart.sku === selectedVariant?.sku && cart.seller.id === seller?.id
        );
        const new_number = isInCartLocal?.number - 1;

        if (new_number > 0) {
            dispatch(actionAddToShoppingCart({
                product, 
                selectedVariant, 
                seller,
                sku: selectedVariant.sku,
                title: product.title,
                number: new_number,
                image: product.image, 
                price: parseInt(seller.price), 
                priceSeparate: seller.priceTxt, 
                marketPrice: parseInt(seller.oldPrice),
                marketPriceSeparate: seller.oldPriceTxt,
                slug
            }));
        } else {
            dispatch(actionRemoveFromShoppingCart({
                product, 
                selectedVariant, 
                seller,
                sku: selectedVariant.sku,
                title: product.title,
                number: 0,
                image: product.image, 
                price: parseInt(seller.price), 
                priceSeparate: seller.priceTxt, 
                marketPrice: parseInt(seller.oldPrice),
                marketPriceSeparate: seller.oldPriceTxt,
                slug
            }));
        }
    };

    return { handleAddToCart, handleMinusBtn, handleAddToCartTwo, handleMinusBtnTwo };
};